module.exports = __webpack_public_path__ + "static/2-25dd8862147b994028afc62697f412fb.svg";